// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-redeclare
import {Text} from '@sede-enterprise/shell-ds-react-framework'
import RcCheckbox from 'rc-checkbox';
import React from 'react';
import cx from 'classnames';
import { ICheckBoxFilter } from '..';
import {
  GridCheckboxFilterMainContainer,
  GridCheckboxFilterContainer,
  GridCheckboxFilterMainOuterContainer,
  CheckboxContainer,
} from './GridCheckboxFilterPanel.styled';

export interface IGridCheckboxFilterProps {
  data?: ICheckBoxFilter<string>;
  disabled?: boolean;
  className?: string;
  small?: boolean;
  color?: string;
  idPrefix?:string;
}

export const GridCheckboxFilterPanel: React.FC<IGridCheckboxFilterProps> = (
  props
) => {
  const classes = cx(
    'shell-checkbox-wrapper',
    {
      'shell-checkbox-wrapper-small': props?.small,
      'shell-checkbox-wrapper-disabled': props?.disabled,
    },
    props?.className
  );

  const dataTestId = props?.idPrefix
    ? props.idPrefix.concat("GridCheckboxFilterPanel")
    : "GridCheckboxFilterPanel";

  return (
    <GridCheckboxFilterContainer data-testid={dataTestId}>
      {props?.data?.columnName}
      <GridCheckboxFilterMainOuterContainer>
        <CheckboxContainer className={classes}>
          <RcCheckbox
            disabled={props?.disabled || false}
            onChange={props?.data?.all.event}
            key={props?.data?.all.value}
            value={props?.data?.all.value}
            checked={props?.data?.all.isChecked}
            prefixCls='shell-checkbox'
            className={props?.color}
          />
          {props?.data?.all?.value && (
            <Text 
                style={{fontSize:'11px',
                fontFamily: "Open Sans,sans-serif",
                fontStyle:"normal",
                fontWeight:600,
                marginLeft:'12px'}} > 
              <span style={{color:''}}>{props?.data?.all?.value}</span> 
            </Text>
          )}
        </CheckboxContainer>
        <hr className='solid' />
        <GridCheckboxFilterMainContainer>
          {props?.data?.valueEvent &&
            props?.data.valueEvent.length > 0 &&
            props?.data.valueEvent.map((item) => (
              <CheckboxContainer key={item.value} className={classes}>
                <RcCheckbox
                  disabled={props?.disabled || false}
                  onChange={item.event}
                  key={item.value}
                  value={item.value}
                  checked={item.isChecked}
                  prefixCls='shell-checkbox'
                  className={props?.color}
                />
                {item?.value && <Text 
                style={{fontSize:'11px',
                fontFamily: "Open Sans,sans-serif",
                fontStyle:"normal",
                fontWeight:600,
                marginLeft:'12px'}} ><span style={{color: item?.color}}>{item.value}</span></Text>}
              </CheckboxContainer>
            ))}
        </GridCheckboxFilterMainContainer>
      </GridCheckboxFilterMainOuterContainer>
    </GridCheckboxFilterContainer>
  );
};

export default GridCheckboxFilterPanel;
